import styled from 'styled-components';

import { DropdownPanelContainer } from '@pkg/components/DropdownPanel/styles';

export const Wrapper = styled.div`
    padding-left: 30px;

    ${DropdownPanelContainer} {
        position: relative;
    }
`;
